import { Component, OnInit } from '@angular/core';
import { Observable, of, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { CigpStaff } from '../cigp-staff/cigp-staff.model';
import { CigpStaffService } from '../cigp-staff/cigp-staff.service';
import { CigpStaffAvatarCardComponent } from '../cigp-staff/cigp-staff-avatar-card.component';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AccountsNavMenuComponent } from '../accounts/accounts-nav-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { UsersNavMenuComponent } from '../users/users-nav-menu.component';
import { ID_PREFIX_CIGP } from '../shared/constants';
import { MotdsNavMenuComponent } from '../motds/motds-nav-menu.component';
import { AuditTrailNavMenuComponent } from '../audit-trail/audit-trail-nav-menu.component';
import { MappingsNavMenuComponent } from '../mappings/mappings-nav-menu.component';
import { TdRatesNavMenuComponent } from '../td-rates/td-rates-nav-menu.component';

@Component({
  selector: 'eaa-nav-menu',
  imports: [
    AccountsNavMenuComponent,
    AsyncPipe,
    AuditTrailNavMenuComponent,
    CigpStaffAvatarCardComponent,
    MappingsNavMenuComponent,
    MatMenuModule,
    MotdsNavMenuComponent,
    RouterLink,
    TdRatesNavMenuComponent,
    UpperCasePipe,
    UsersNavMenuComponent
  ],
  template: `
    <nav class="navbar fixed-top navbar-expand-lg navbar-light bg-white">
      @if (loggedIn) {
        <div class="container-fluid d-flex justify-content-between">
          <a class="navbar-brand" [routerLink]="['/']">
            <img src="cigp-logo.png" style="width: 40px" alt="CIGP" />
            <span class="mx-3">E-Platform Admin</span>
            @if (environment !== 'production') {
              <span class="badge text-success-emphasis bg-success-subtle">{{ environment | uppercase }}</span>
            }
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav d-flex align-items-center">
              <eaa-accounts-nav-menu></eaa-accounts-nav-menu>
              <eaa-users-nav-menu></eaa-users-nav-menu>
              <eaa-mappings-nav-menu />
              <eaa-motds-nav-menu></eaa-motds-nav-menu>
              <eaa-td-rates-nav-menu />
              <eaa-audit-trail-nav-menu></eaa-audit-trail-nav-menu>
            </ul>
            <div class="me-auto"></div>
            <ul class="navbar-nav d-flex align-items-center">
              @if (feedbackForm) {
                <li class="nav-item">
                  <a class="nav-link" [href]="feedbackForm" target="_blank" style="width: 120px" class="text-black-50"
                    >FEEDBACK</a
                  >
                </li>
              }
              @if (userManual) {
                <li class="nav-item">
                  <a class="nav-link" [href]="userManual" target="_blank"
                    ><span class="bi bi-question-circle" aria-hidden="true"></span
                  ></a>
                </li>
              }

              <eaa-cigp-staff-avatar-card [user]="me$ | async" />
            </ul>
          </div>
        </div>
      }
    </nav>
  `
})
export class NavMenuComponent implements OnInit {
  public me$: Observable<CigpStaff | null> | null = null;
  public feedbackForm = environment.feedbackForm;
  public userManual = environment.userManual;
  public environment = environment.env;
  public loggedIn = false;

  constructor(
    private eaccessAuthService: EaccessAuthService,
    private usersService: CigpStaffService
  ) {}

  public ngOnInit(): void {
    this.eaccessAuthService.loggedIn$.subscribe((loggedIn) => {
      this.loggedIn = loggedIn;

      this.me$ = this.eaccessAuthService
        .getActiveAccount$()
        .pipe(
          switchMap((account) =>
            account ? this.usersService.getStaffFromCache$(`${ID_PREFIX_CIGP}${account.localAccountId}`) : of(null)
          )
        );
    });
  }
}
